import { render } from "./Pep.vue?vue&type=template&id=15d454fa&scoped=true"
import script from "./Pep.vue?vue&type=script&lang=js"
export * from "./Pep.vue?vue&type=script&lang=js"

import "./Pep.vue?vue&type=style&index=0&id=15d454fa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d454fa"]])

export default __exports__